export enum segmentType {
    middle = 'middle',
}